import { useState } from "react";
import {
  creativesscript_g_icon,
  creativesscript_icon,
  matrixmarketing_icon,
  taskcenter_g_icon,
  taskcenter_icon,
  teammanagement_g_icon,
  teammanagement_icon,
  videoclip_g_icon,
  videoclip_icon,
  workbench_g_iocn,
  workbench_iocn,
  creativespace_g_icon,
  creativespace_icon,
  videoclip_w_icon,
  onekey_w_icon,
  pictureposter_w_icon,
  creativesscript_w_icon,
  videoparsing_w_icon,
  hello_icon,
  faddish_icon,
  team_icon,
  team_people_icon,
  create_center_icon,
  voice_clone_icon,
  hotInActive,
  hotActive,
  seo_active,
  seo_icon,
  seo_ranking,
  seo_setting,
  matrix_web,
  matrix_down,
  human_icon,
  human_icon_active,
  czgj_icon,
  cloud_cut,
  quick_cut,
  script_cut,
} from "@/assets/workbenchimage";
import { Permissions } from "@/components/business/RolePermission/permissions";
import { getTokenToLocalStorage } from "@/utils/token";
import {
  create_script,
  hot_tag,
  hot,
  Inspiration,
  Inspiration_tag,
  Inspiration_w,
  subscription_tag,
} from "@/assets/Inspiration-center";
import appStore from "@/stores/appStore";
function useData() {
  const [menuList] = useState([
    {
      id: "1",
      title: "工作台",
      path: "/work-bench",
      icon: [workbench_g_iocn, workbench_iocn],
      hot: false,
    },
    ...(!appStore.isOdm
      ? [
        {
          id: "2",
          title: "灵感中心",
          children: [
            {
              id: "2-1",
              subTitle: "平台热榜概览",
              path: "/hot",
              icon: {
                svg: hot_tag,
                color: "linear-gradient( 131deg, #F6676F 0%, #FFB273 100%)",
              },
            },
            {
              id: "2-2",
              subTitle: "行业订阅观察",
              path: "/industry-subscribe",
              icon: {
                svg: subscription_tag,
                color: "linear-gradient( 135deg, #427BFF 0%, #6EC6FF 100%)",
              },
              permissions: Permissions.AIVideoAnalysis,
            },
            // {
            //   id: "2-3",
            //   subTitle: "创作灵感速递",
            //   path: "/",
            //   icon: {
            //     svg: Inspiration_tag,
            //     color: "linear-gradient( 131deg, #964CF7 0%, #D3B2FE 100%)",
            //   },
            //   permissions: Permissions.AIThemeCreation,
            // },
          ],
          icon: [Inspiration_w, Inspiration],
          hot: false,
          permissions: Permissions.CreativeScript,
        },
      ]
      : [
        {
          id: "2",
          title: "热榜推荐",
          path: "/hot",
          icon: [hotInActive, hotActive],
        },
      ]),
    // {
    //   id: "3",
    //   title: "创作空间",
    //   children: [
    //     {
    //       id: "3-1",
    //       subTitle: "我的创作",
    //       path: "/creative-space",
    //       icon: {
    //         svg: creativespace_icon,
    //         color: "linear-gradient( 132deg, #FF8F1F 0%, #FFD9B2 100%)",
    //       },
    //       permissions: Permissions.CreativeSpace,
    //     },
    //     {
    //       id: "3-2",
    //       subTitle: "创作工具",
    //       path: "/creative-space",
    //       icon: {
    //         svg: creativespace_icon,
    //         color: "linear-gradient( 132deg, #FF8F1F 0%, #FFD9B2 100%)",
    //       },
    //       permissions: Permissions.CreativeSpace,
    //     },
    //   ],
    //   icon: [creativespace_g_icon, creativespace_icon],
    // },
    {
      id: "3",
      title: "创作空间",
      children: [
        {
          id: "3-1",
          subTitle: "我的创作",
          path: "/creative-space",
          icon: {
            svg: create_center_icon,
            color: "linear-gradient( 131deg, #7F63F1 0%, #C1B2FF 100%)",
          },
          permissions: Permissions.CreativeSpace,
        },
        {
          id: "3-2",
          subTitle: "创作工具",
          path: "/creative-tool",
          icon: {
            svg: czgj_icon,
            color: "linear-gradient( 135deg, #427BFF 0%, #6EC6FF 100%)",
          },
          permissions: Permissions.CreativeSpace,
        },
        // {
        //   id: "3-2",
        //   subTitle: "音色克隆",
        //   path: "/voice-list",
        //   icon: {
        //     svg: voice_clone_icon,
        //     color: "linear-gradient( 135deg, #427BFF 0%, #6EC6FF 100%)",
        //   },
        //   permissions: Permissions.CreativeSpace,
        // },
      ],
      icon: [creativespace_g_icon, creativespace_icon],
    },
    {
      id: "4",
      title: "创意脚本",
      children: [
        {
          id: "4-1",
          subTitle: "创建脚本",
          path: "/creation-script",
          icon: {
            svg: create_script,
            color: "linear-gradient( 131deg, #964CF7 0%, #D3B2FE 100%)",
          },
        },
        ...(!appStore.isOdm
          ? [
            {
              id: "4-2",
              subTitle: "脚本工厂",
              path: "/creative-script",
              icon: {
                svg: faddish_icon,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
              permissions: Permissions.HotScript,
            },
          ]
          : []),
        {
          id: "4-3",
          subTitle: "AI视频解析",
          path: "/analysis-video",
          icon: {
            svg: videoparsing_w_icon,
            color: "linear-gradient( 132deg, #FF8F1F 0%, #FFD9B2 100%)",
          },
          permissions: Permissions.AIVideoAnalysis,
        },
        ...(!appStore.isOdm
          ? [
            {
              id: "4-4",
              subTitle: "行业主题脚本",
              path: "/ai-creation",
              icon: {
                svg: creativesscript_w_icon,
                color:
                  "linear-gradient( 129deg, #38BEDE 0%, rgba(65,199,231,0.6157) 100%)",
              },
              permissions: Permissions.AIThemeCreation,
            },
          ]
          : []),
      ],
      icon: [creativesscript_g_icon, creativesscript_icon],
      hot: false,
      permissions: Permissions.CreativeScript,
    },
    {
      id: "5",
      title: "智剪魔方",
      children: [
        ...(!appStore.isOdm
          ? [
            {
              id: "5-4",
              subTitle: "AI讯剪",
              path: "/quick-cut",
              icon: {
                svg: quick_cut,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
            },
            {
              id: "5-5",
              subTitle: "AI云剪",
              path: "/cloud-clip",
              icon: {
                svg: cloud_cut,
                color: "linear-gradient( 131deg, #3ABEDE 0%, #86DBF0 100%)",
              },
              permissions: Permissions.IntelligentEditing,
            },
            {
              id: "5-1",
              subTitle: "智能魔剪",
              path: "/video-clips",
              icon: {
                svg: videoclip_w_icon,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
              permissions: Permissions.IntelligentEditing,
            },
            {
              id: "5-6",
              subTitle: "脚本剪辑",
              path: "/mix-detail",
              icon: {
                svg: script_cut,
                color: "linear-gradient( 131deg, #FF9327 0%, #FFD7AE 100%)",
              },
              permissions: Permissions.IntelligentEditing,
            },
          ]
          : [
            {
              id: "5-1",
              subTitle: "智能魔剪",
              path: "/mix-detail",
              icon: {
                svg: videoclip_w_icon,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
              permissions: Permissions.IntelligentEditing,
            },
          ]),

        {
          id: "5-2",
          subTitle: "图文创作",
          path: "/image-text",
          // graphicediting
          icon: {
            svg: pictureposter_w_icon,
            color: "linear-gradient( 131deg, #964CF7 0%, #D3B2FE 100%)",
          },
        },
        ...(!appStore.isOdm
          ? [
            {
              id: "5-3",
              subTitle: "一键成片",
              path: "/",
              // accomplish
              icon: {
                svg: onekey_w_icon,
                color: "linear-gradient( 135deg, #427BFF 0%, #6EC6FF 100%)",
              },
            },
          ]
          : []),
      ],
      icon: [videoclip_g_icon, videoclip_icon],
      hot: false,
    },
    {
      id: "9",
      title: "SEO视频",
      children: [
        {
          id: "9-1",
          subTitle: "关键词配置",
          path: "/seo-setting",
          icon: {
            svg: seo_setting,
            color: "linear-gradient( 131deg, #40C1E0 0%, #9BE6F7 100%)",
          },
        },
        ...(!appStore.isOdm
          ? [
            {
              id: "9-2",
              subTitle: "关键词排名",
              path: "/seo-ranking",
              icon: {
                svg: seo_ranking,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
              // permissions: Permissions.SeoSetting,
            },
          ]
          : []),
        {
          id: "9-3",
          subTitle: "生成结果",
          path: "/seo-result",
          icon: {
            svg: seo_setting,
            color: "linear-gradient( 131deg, #40C1E0 0%, #9BE6F7 100%)",
          },
          hidden: true,
        },
      ],
      icon: [seo_icon, seo_active],
      hot: false,
      // permissions: Permissions.SEO,
    },

    {
      id: "7",
      title: "矩阵营销",
      // path: `/matrix`,
      icon: [matrixmarketing_icon, matrixmarketing_icon],
      // blank: true,
      hot: true,
      font: true,
      permissions: Permissions.MatrixMarketing,
      children: [
        {
          id: "7-1",
          subTitle: "智能营销",
          path: "/matrix",
          blank: true,
          icon: {
            svg: matrix_web,
            color: "linear-gradient( 131deg, #7F63F1 0%, #C1B2FF 100%)",
          },
        },
        {
          id: "7-2",
          subTitle: "客户端下载",
          path: "/matrix",
          icon: {
            svg: matrix_down,
            color: "linear-gradient( 135deg, #427BFF 0%, #6EC6FF 100%)",
          },
        },
      ],
    },
    // {
    //   id: "3000",
    //   title: "测试模块",
    //   path: "/testupload",
    //   icon: [0, 0],
    //   hot: false,
    // },
    {
      id: "12",
      title: "数字人",
      path: "/digital-human-list",
      icon: [human_icon, human_icon_active],
      hot: false,
    },
    ...(!appStore.isOdm
      ? [
        {
          id: "6",
          title: "团队管理",
          children: [
            {
              id: "6-1",
              subTitle: "团队概览",
              path: "/team-overview",
              icon: {
                svg: team_icon,
                color: "linear-gradient( 131deg, #417AFF 0%, #73CEFF 100%)",
              },
            },
            ...(!appStore.isOdm
              ? [
                {
                  id: "6-2",
                  subTitle: "团队成员",
                  path: "/team-anagement",
                  icon: {
                    svg: team_people_icon,
                    color:
                      "linear-gradient( 135deg, #8E3FF6 0%, #CEA9FF 100%)",
                  },
                },
              ]
              : []),
          ],
          icon: [teammanagement_g_icon, teammanagement_icon],
          hot: false,
          permissions: Permissions.TeamManagement,
        },
      ]
      : []),
    {
      id: "8",
      title: "任务中心",
      path: "/task-center",
      icon: [taskcenter_g_icon, taskcenter_icon],
      hot: false,
      permissions: Permissions.TaskCenter,
    },
  ]);
  return { menuList };
}

export default useData;
